(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chatBox"] && !Shopify.designMode) return;
  try {
    


const chat_api_key = "fZhq0OeImPrG8RLmAm6Iz7vG26FpdN7BlLrvUm9Ds8Q="

const chatInput = document.querySelector("#chatInput #chatInputField")
const sendBtn = document.querySelector("#chatInput #sendChatBtn")

// Get the image paths from the data attributes
var imagePathsElement = document.getElementById('imagePaths');
const defaultMascot = imagePathsElement.getAttribute('data-image-1')
const userIcon = imagePathsElement.getAttribute('data-image-0')
var imagePaths = [
    imagePathsElement.getAttribute('data-image-2'),
    imagePathsElement.getAttribute('data-image-3')
];

function scrollChatBoxToBottom() {
    const chatbox = document.getElementById('chatBox');
    chatbox.scrollTop = chatbox.scrollHeight;
}

function showLoader(show) {

    const loaderSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle fill="#FF156D" stroke="#FF156D" stroke-width="15" r="15" cx="40" cy="100"><animate attributeName="opacity" calcMode="spline" dur="2" values="1;0;1;"keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.4"></animate></circle><circle fill="#FF156D" stroke="#FF156D" stroke-width="15" r="15" cx="100" cy="100"><animate attributeName="opacity" calcMode="spline" dur="2" values="1;0;1;"keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.2"></animate></circle><circle fill="#FF156D" stroke="#FF156D" stroke-width="15" r="15" cx="160" cy="100"><animate attributeName="opacity" calcMode="spline" dur="2" values="1;0;1;"keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="0"></animate></circle></svg>`

    // show chat loading
    const loader = document.createElement('div');
    loader.id = 'chatLoader';
    loader.style.width = "3rem"
    loader.innerHTML = loaderSVG

    const chatBox = document.getElementById("chatBox");

    if (show) {
        chatBox.appendChild(loader);
        scrollChatBoxToBottom()

        // disable send chat btn
        sendBtn.disabled = true
        return;
    }

    chatBox.removeChild(document.getElementById("chatLoader"));
    sendBtn.disabled = false;
    return
}

function toggleStartChatForm(show) {

    if (show) {
        document.getElementById("startChatForm").style.display = "flex"
        document.getElementById("chatBox").style.display = "none"
        document.getElementById("chatInput").style.display = "none"
        return;
    }

    document.getElementById("startChatForm").style.display = "none"
    document.getElementById("chatBox").style.display = "flex"
    document.getElementById("chatInput").style.display = "grid"

}

function renderChatHistory() {
    const chatHistory = localStorage.getItem("chat_history")
    const chatBox = document.querySelector('#chatBox');
    if (chatHistory) {
        chatBox.innerHTML = chatHistory
    }
    return;
}

var chatBoxOpen = false;

document.getElementById("close-btn").addEventListener("click", (elem) => {
    const container = document.getElementById('fixed-container');
    if (chatBoxOpen) {
        container.setAttribute("collapsed", true)
        chatBoxOpen = false;
    } else {
        container.setAttribute("collapsed", false)
        chatBoxOpen = true;
        scrollChatBoxToBottom()
    }
})

function clearChat() {
    // reset history and session details
    localStorage.removeItem("chat_id")
    localStorage.removeItem("chat_history")
    localStorage.removeItem("sessionStartStamp")

    // clear chatBox
    document.getElementById("chatBox").innerHTML = ""

    // clear input filed
    document.getElementById("nameInput").value = ""

    // clear chatInput
    document.getElementById("chatInputField").value = ""
    // show start chat form
    toggleStartChatForm(true)
}

document.getElementById("clearChatBtn").addEventListener("click", () => {
    clearChat()
})

// add event to start chat - start chat form

function nameNotEmpty() {
    const name = document.getElementById("nameInput")
    if (name.value !== "") return true

    // add shake animation to name file
    name.classList.add("shake");

    // Remove the shake class after the animation ends so it can be triggered again
    setTimeout(() => {
        name.classList.remove("shake");
    }, 500)

    return false;

}

const options = document.getElementsByClassName("genderSelectOption")

function greetText(name) {
    return {
        "message": `Hey ${name}, <br/>
    Great to meet you! <br/>
    I’m here to help you navigate your way through the Cava ecosystem and join the #CavaClub without any difficulties. <br/> <br/> 
    Here’s a few things you can ask me: <br/>
    - I’m looking for a cute top for my next Pilates session, do you have any suggestions? <br/>
    - What are the current offers that you guys are running? <br/>
    - any flare legging recommendations for a short girl?<br/>
    `}
}

options.item(0).addEventListener("click", async (event) => {
    if (nameNotEmpty()) {
        const gender = event.target.innerHTML
        const name = document.getElementById("nameInput").value

        const aiRes = await startChat(name, gender)
        appendAIChatBubble(greetText(name))
    }
})

options.item(1).addEventListener("click", async (event) => {
    if (nameNotEmpty()) {
        const gender = event.target.innerHTML
        const name = document.getElementById("nameInput").value

        const aiRes = await startChat(name, gender)
        appendAIChatBubble(greetText(name))
    }
})

// update ChatBox functions

function appendUserChatBubble(userText) {
    const chatBox = document.getElementById('chatBox');
    chatBox.innerHTML += `<div class="user-chatBubble">
    <p>${userText}</p>
    <img class="chatbotMascotImage" src=${userIcon} height="25" width="25" alt="mascot">
    </div>`;
    scrollChatBoxToBottom()
}

function appendAIChatBubble(AIChat) {
    const chatBox = document.getElementById('chatBox');

    chatBox.innerHTML += `
    <div class="ai-chatBubble">
    <img class="chatbotMascotImage" src=${defaultMascot} height="25" width="25" alt="mascot">

    <div class="ai-chatText">

        ${AIChat.message}

        ${AIChat.products ? `<div class="products">
        ${AIChat.products.map((product) => {

        if (product.name === null || product.image_url === null || product.price === null || product.product_url === null) return;

        return `
            <div class="productCard">
                <img src="${product.image_url}"
                    alt="productImage" class="productImage" />
                <div class="prodictDetails">
                    <span class="productTitle">${product.name}</span>
                    <span class="productPrice">Rs. ${product.price}</span>
                </div>
                <a href="${product.product_url}" ><button class="viewBtn">View Product</button><a/>
                
            </div>
            `
    }).join("")}

    </div>` : ""}

    </div>
    </div>
    `
    scrollChatBoxToBottom()

    // store chat history
    const chatHistory = document.getElementById("chatBox").innerHTML
    localStorage.setItem("chat_history", chatHistory)
}

// chat api calls

const baseURL = "https://cava-api-414416157808.asia-south1.run.app"

async function startChatSession() {

    // if chat session exists
    if (localStorage.getItem("chat_id") !== null) {
        renderChatHistory()
        return;
    }

    await fetch(`${baseURL}/header`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'x-api-key': chat_api_key
        },
    })
        .then(async (res) => {
            const currTime = new Date()
            const sessionId = (await res.json())['chat-id'];
            localStorage.setItem("chat_id", sessionId);
            localStorage.setItem("sessionStartStamp", currTime.getTime());
            toggleStartChatForm(false)
        })
        .catch(error => {
            toggleStartChatForm(true)
            console.error('Error:', error);
        });

}

async function startChat(name, gender) {

    toggleStartChatForm(false)

    showLoader(true)
    scrollChatBoxToBottom()

    try {

        await startChatSession()

        // Make the POST request
        const response = await fetch(`${baseURL}/chat`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'x-api-key': chat_api_key,
                'Content-Type': 'application/json',
                "chat-id": localStorage.getItem("chat_id")
            },
            // credentials: 'include',
            body: JSON.stringify({
                name: name,
                gender: gender
            })
        });

        // Check if the response is successful
        if (!response.ok) {
            alert("Please use appropriate language!")
            clearChat()
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // get ai response
        const data = await response.json();

        // remove loader
        showLoader(false)
        
        return data;
    } catch (error) {
        console.error('Error starting chat:', error);
    }
}

async function sendChat(text) {
    try {

        const response = await fetch(`${baseURL}/chat/messages`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'x-api-key': chat_api_key,
                'Content-Type': 'application/json',
                "chat-id": localStorage.getItem("chat_id")
            },
            body: JSON.stringify({
                message: text
            })
        });

        // Check if the response is successful
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse and return the response data
        const data = await response.json();

        console.log("send chat : ", data)
        return data
    } catch (error) {
        console.error('Error starting chat:', error);
        throw error;
    }
}


// handle chat events
chatInput.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
        event.preventDefault()
        sendBtn.click()
    }
})

sendBtn.addEventListener("click", async (event) => {
    const text = chatInput.value
    if (text !== "") {
        appendUserChatBubble(text)
        chatInput.value = ""

        // show chat loading
        showLoader(true)

        // get chat response
        try {
            const aiResponse = await sendChat(text)
            
            // remove loader
            showLoader(false)
            
            // append ai message
            appendAIChatBubble(aiResponse)
        }catch {
         
            // remove loader and show error
            showLoader(false)
            appendAIChatBubble({message: "something went wrong!!"})    
            
        }
    }
})



// Update chatbot mascot randomly

document.addEventListener('DOMContentLoaded', function () {

    function updateImageSrc() {
        const mascotImageElement = document.getElementById("chatbotMascotImage");

        var randomImage = imagePaths[Math.floor(Math.random() * imagePaths.length)];

        mascotImageElement.src = randomImage;

        setTimeout(() => {
            mascotImageElement.src = defaultMascot;
        }, 300);
    }

    function setRandomInterval() {
        var randomInterval = Math.floor(Math.random() * (10000 - 5000 + 1)) + 5000; 
        setTimeout(function () {
            updateImageSrc();        
            setRandomInterval();     
        }, randomInterval);
    }

    setRandomInterval();
});


function checkSessionTime() {
    const sessionStartStamp = localStorage.getItem('sessionStartStamp');

    if (sessionStartStamp) {
        const currentTime = new Date().getTime();
        const sessionStart = parseInt(sessionStartStamp, 10); 

        if (sessionStart > currentTime) {
            clearChat(); 
            return true;
        }

        const timeDifference = (currentTime - sessionStart) / (1000 * 60);

        if (timeDifference > 30) {
            clearChat(); 
            return true;
        }
    } else {
        clearChat();
        return true;
    }

    return false; 
}


function checkSession() {
    if (localStorage.getItem("chat_id") !== null) {
        if (checkSessionTime()) return; 
        toggleStartChatForm(false)
        renderChatHistory()
        return
    }
    toggleStartChatForm(true)
}

checkSession()


  } catch(e) { console.error(e); }
})();
})();
